import { useState, useEffect, useRef, useCallback } from "react";

const useInfiniteScroll = (fetchItemsCallback, direction) => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(2);
  const [hasMore, setHasMore] = useState("next");
  const scrollContainerRef = useRef(null);
  const [offset, setOffset] = useState(1);
  const isFetchingRef = useRef(false); 

  const fetchItems = async () => {
    // console.log(loading , isFetchingRef.current,hasMore)
    if (!loading && !isFetchingRef.current && hasMore) {
      setLoading(true);
      isFetchingRef.current = true; 
      try {
        // console.log("fetchf",page)
        const data = await fetchItemsCallback(page);
        if (data.status) {
          setPage(prevPage => prevPage + 1);
          setHasMore(data.next);
        }
      } catch (error) {
        console.error("Error fetching items:", error);
      } finally {
        setLoading(false);
        isFetchingRef.current = false; // Reset fetch status
      }
    }
  };

  const handleScroll = useCallback(() => {
    const scrollContainer = scrollContainerRef.current;
    const isAtEnd =
      direction === "vertical"
        ? scrollContainer.scrollTop + scrollContainer.clientHeight >=
          scrollContainer.scrollHeight - offset
        : scrollContainer.scrollLeft + scrollContainer.clientWidth >=
          scrollContainer.scrollWidth - offset;
 
          // console.log(scrollContainer.scrollTop + scrollContainer.clientHeight,
          //   scrollContainer.scrollHeight - offset,isAtEnd)

    // if (isAtEnd && !localStorage.getItem("appData")) {
      if (isAtEnd) {
      fetchItems();
    }
  }, [direction, offset, fetchItems]);

  // Debounce handleScroll function to prevent rapid firing
  const debounceScroll = useCallback(
    debounce(handleScroll, 200),
    [handleScroll]
  );

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    scrollContainer.addEventListener("scroll", debounceScroll);

    return () => {
      scrollContainer.removeEventListener("scroll", debounceScroll);
    };
  }, [debounceScroll]);

  return { scrollContainerRef, hasMore, loading,setPage,setHasMore };
};


function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export default useInfiniteScroll;
